<div class="input-currencies">
  <div class="input-container">
    <app-form-input [control]="control()" [label]="label()">
      <input class="input input--simple" (keydown.enter)="onBlur($event)" [formControl]="control()" type="number" min="0">
    </app-form-input>
  </div>
  <app-currency-selector-standalone (changeCurrency)="changeCurrency.emit($event)" [selectedCurrency]="selectedCurrency()" [disable]="disableSelect()"></app-currency-selector-standalone>
</div>

